export enum TrialType {
  TABLEAU_AI = 'TABLEAU_AI',
}

export enum TrialStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}

export interface ISiteTrial {
  id: string;
  trialType: TrialType;
  status: TrialStatus;
  expiresAt: string;
  onboardedFeatures: string[];
  canRestart: boolean;
  restartFeatures: string[];
}
